import { MultipleItemsBlock } from './MultiplItemsBlock';

export { MultipleItemsBlock };
export default MultipleItemsBlock;
